'use strict';

// http://262.ecma-international.org/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/2021/ToBoolean.js
// module id = 175
// module chunks = 0